
const decodeText = (value?: string | null): string => {
  if (!value) return '';

  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

type BacklinkAnchorTextCellProps = {
  anchor?: string | null;
  textPre?: string | null;
  textPost?: string | null;
  url?: string | null;
};

const BacklinkAnchorTextCell = ({
  anchor,
  textPre,
  textPost,
  url
}: BacklinkAnchorTextCellProps) => {
  const pre = decodeText(textPre).trim();
  const anchorText = decodeText(anchor).trim();
  const post = decodeText(textPost).trim();
  const fallback = anchorText || '[بدون متن پیوند]';
  const title = [pre, anchorText, post].filter(Boolean).join(' ');

  return (
    <div className="backlink-anchor-text-cell" title={title || fallback}>
      {pre && <span className="backlink-anchor-text-context">{pre} </span>}
      {anchorText ? (
        <a
          className="backlink-anchor-text-link"
          href={decodeText(url)}
          target="_blank"
          rel="noreferrer"
        >
          {anchorText}
        </a>
      ) : (
        <span className="backlink-anchor-text-fallback">{fallback}</span>
      )}
      {post && <span className="backlink-anchor-text-context"> {post}</span>}
    </div>
  );
};

export default BacklinkAnchorTextCell;
